import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
  Avatar,
} from "@mui/material";
import "../../Styles/Layouts/common_topbar.css";
import { useNavigate, Link } from "react-router-dom";
import instance from "../../utils/api";

const Topbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [vendorName, setVendorName] = useState([]);

  const getVendorName = async () => {
    try {
      const response = await instance.get("/vendor/getVendorDetails");
      setVendorName(response.data.vendor.name);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getVendorName();
  }, []);

  const handleClose = () => {
    setAnchorEl(null);
  };

  //logout function
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/admin/Profile`);
  };

  return (
    <div className="topbar">
      <Box>
        <Typography variant="h3">Welcome {vendorName}</Typography>
        <div>
          <Tooltip title="Account">
            <IconButton
              onClick={handleClick}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar />
            </IconButton>
          </Tooltip>
          <Menu
            className="menu-container"
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem onClick={handleNavigate}>Profile</MenuItem>
            <MenuItem>
              <Link className="link" to="/admin/Admin_Resetpassword">
                Reset Password{" "}
              </Link>
            </MenuItem>
          </Menu>
        </div>
      </Box>
    </div>
  );
};

export default Topbar;
